import React, { Component } from 'react'
import SearchContainer from './../../containers/BooksSearchContainer'
import PaginationContainer from './../../containers/PaginationContainer/Books'
import FilterBooksContainer from './../../containers/FilterContainers/Books'
import BookItem from './../BookItem'
import BreadcrumbContainer from './../../containers/BreadcrumbContainer'

class Books extends Component {
  render () {
    const { books, handleOpenModal, handlePageClick } = this.props
    return (
      <div>
        <div className='main-header'>
          <div className='main-header__column'>
            <BreadcrumbContainer />
          </div>
        </div>
        <SearchContainer />
        <div className='modal__filter'>
          <FilterBooksContainer />
        </div>
        {books.length > 0
        ? <ul className='modal__list-items'>
          {books.map((item) => (
            <BookItem
              key={item.id}
              handleOpenModal={handleOpenModal}
              item={item}
              gradeId={this.props.grade}
            />
          ))
          }
        </ul>
        : <p>Não foram encontrados livros.</p>
        }
        <PaginationContainer handlePageClick={handlePageClick} />
      </div>
    )
  }
}

export default Books



// WEBPACK FOOTER //
// ./src/components/Books/index.js